import React from 'react'
import { Link } from 'react-router-dom'

function BlogGridleft() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Blog Grid Left</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Section Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row">
                <aside className="col-lg-4">
                    <div className="sidebar">
                        <div className="sidebar_inner">
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Search</h5>
                                <form action="#" method="POST">
                                    <div className="input-group">
                                        <input type="text" name="#" className="form-control form-control-custom" placeholder="Search keywords..." autoComplete="off" required=""/>
                                        <div className="input-group-append">
                                            <button type="submit">
                                                <i className="fal fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Category</h5>
                                <ul className="categories">
                                    <li>
                                        <Link to="/blog-grid">Fitness <span>(267)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Health <span>(50)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Lifestyle <span>(78)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Nutrition <span>(95)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Sport <span>(15)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Science <span>(65)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Training <span>(62)</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/blog-grid">Program <span>(85)</span></Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Recent Post</h5>
                                <ul className="recent_post">
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">You Will Become As Off Small Your Desire.</Link></h6>
                                            <p className="post_date">20 Fab 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy.</Link></h6>
                                            <p className="post_date">18 Fab 2024</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="post_thumb">
                                            <Link to="/blog-details">
                                                <img src="/tm/react/fit2fine/assets/images/blog/3.jpg" className="image-fit" alt="img"/>
                                            </Link>
                                        </div>
                                        <div className="post_caption">
                                            <h6 className="post_title"><Link to="/blog-details">How to Maximise Time Spent at the Gym.</Link></h6>
                                            <p className="post_date">15 Fab 2024</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="sidebar_widget">
                                <h5 className="widget_title">Tags</h5>
                                <div className="tags_cloud">
                                    <Link to="/blog-grid">Fitness </Link>
                                    <Link to="/blog-grid">Health</Link>
                                    <Link to="/blog-grid">Lifestyle</Link>
                                    <Link to="/blog-grid">Nutrition</Link>
                                    <Link to="/blog-grid">Sport</Link>
                                    <Link to="/blog-grid">Science</Link>
                                    <Link to="/blog-grid">Training</Link>
                                    <Link to="/blog-grid">Program</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
                <div className="col-lg-8">
                    <div className="row justify-content-center">
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                20 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">You Will Become As Off Small Your Desire. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                      
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                18 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                      
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                15 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                       
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/4.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                14 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">Simple Condition for all Around Fitness. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                       
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/5.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                14 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                      
                        <article className="col-md-6">
                            <div className="post post_grid">
                                <div className="post_image">
                                    <Link to="/blog-details" className="d-flex h-100">
                                        <img src="/tm/react/fit2fine/assets/images/blog/6.jpg" alt="img" className="image-fit"/>
                                    </Link>
                                </div>
                                <div className="post_caption">
                                    <ul className="post_meta">
                                        <li>
                                            <Link to="/blog-details">
                                                <i className="bi-calendar3"></i>
                                                10 Fab 2024
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/blog-grid">
                                                <i className="bi-person"></i>
                                                by Admin
                                            </Link>
                                        </li>
                                    </ul>
                                    <h2 className="post_title">
                                        <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                                    </h2>
                                    <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                                </div>
                                <div className="post_footer">
                                    <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                                </div>
                            </div>
                        </article>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <nav>
                                <ul className="pagination">
                                    <li className="page-item">
                                        <Link className="page-link" to="#">
                                            Previous
                                        </Link>
                                    </li>
                                    <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                                    <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                                    <li className="page-item">
                                        <Link className="page-link" to="#">
                                            Next
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogGridleft